import React from 'react';

import { useTranslations } from 'next-intl';

import buildRouteUrl from '../../helpers/buildRouteUrl';
import { WatchProviderTitle } from '../../types/types';
import CarouselSection from '../CarouselSection';
import WatchProvider from '../WatchProvider';

interface PropTypes {
  id: string;
  contentTitle?: string;
  data: WatchProviderTitle[];
  className?: string;
}

function WatchProvidersList({ id, contentTitle, data, className }: PropTypes) {
  const t = useTranslations();

  const watchProviders = data
    .filter((v, i, a) => a.findIndex(t => t.url === v.url) === i)
    .filter(
      watchProviderOffer =>
        !(
          watchProviderOffer.provider.slug === 'unofficial' ||
          watchProviderOffer.provider.slug === 'theater'
        )
    );

  if (watchProviders.length > 0) {
    return (
      <CarouselSection
        id={id}
        title={t('watch_providers_list.title', {
          content_title: contentTitle || ''
        })}
        type="watch_provider"
        totalItems={watchProviders.length || 0}
        className={className}
      >
        {watchProviders.map(watchProviderOffer => (
          <a
            className="mr-2"
            target="_blank"
            rel="noreferrer"
            key={`${watchProviderOffer.url}-${watchProviderOffer.monetization_type}`}
            href={buildRouteUrl(watchProviderOffer.url)}
          >
            <div className="embla__slide">
              <WatchProvider
                data={watchProviderOffer.provider}
                alt={t('watch_providers_list.alt', {
                  content_title: contentTitle,
                  watch_provider_name: watchProviderOffer.provider.name
                })}
              />
            </div>
          </a>
        ))}
      </CarouselSection>
    );
  } else {
    return <div />;
  }
}

export default WatchProvidersList;
